export class FindAllGroupRolesError {
  public static readonly type = '[Group/Users/List] FindAllGroupRolesError';
  constructor(public readonly error: Error) {}
}
